// src/hooks/useAuth.js
import { useState, useCallback, useEffect } from 'react';
import { api } from '../api/api';

export const useAuth = () => {
  const [user, setUser] = useState(null);
  // Si ya terminó la comprobación de sesión, con o sin usuario.
  //
  // Lo necesita el selector de país de la primera visita: preguntarle el país a
  // alguien que ya lo tiene guardado en su cuenta sería molestarlo con algo que
  // ya contestó, y `user` llega asíncrono.
  const [authListo, setAuthListo] = useState(false);

  const checkAuthStatus = useCallback(async () => {
    try {
      const userData = await api.checkAuthStatus();
      setUser(userData);
      return userData;
    } catch (error) {
      console.error('Auth check failed:', error);
      setUser(null);
      return null;
    } finally {
      setAuthListo(true);
    }
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('token');
    setUser(null);
  }, []);

  // El token JWT expira (JWT_EXPIRE_MINUTES). Cuando cualquier llamada
  // autenticada devuelve 401/403, api.js emite 'auth:expired' y cerramos sesión
  // para que la UI no siga mostrando al usuario como logueado.
  useEffect(() => {
    const onExpired = () => setUser(null);
    window.addEventListener('auth:expired', onExpired);
    return () => window.removeEventListener('auth:expired', onExpired);
  }, []);

  return {
    user,
    setUser,
    authListo,
    checkAuthStatus,
    logout
  };
};